import styled from 'styled-components';

import { variable } from '../../helpers/style.helpers';

interface CellWrapperProps {
  width?: string;
}

const CellWrapper = styled.td<CellWrapperProps>`
  width: ${({ width }) => width};
  padding: ${variable.space.xxxs}px ${variable.space.s}px;
`;

export interface TableCellProps {
  children: React.ReactNode;
  colSpan?: number;
  width?: string;
}

export function TableCell({ children, width, colSpan }: TableCellProps) {
  return (
    <CellWrapper colSpan={colSpan} width={width}>
      {children}
    </CellWrapper>
  );
}
